import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import * as React from "react";
import { ComingSoonProvider } from "./context/comingSoon";
import { applyRouteMeta, getRouteMeta } from "./seo";
import { AboutPage } from "./pages/AboutPage";
import { CareersPage } from "./pages/CareersPage";
import { ComingSoonPage } from "./pages/ComingSoonPage";
import { DataPlatformPage } from "./pages/DataPlatformPage";
import { HomePage } from "./pages/HomePage";
import { IntegrationPage } from "./pages/IntegrationPage";
import { LegacyProductRedirect } from "./pages/LegacyProductRedirect";
import { LegalEntityPage } from "./pages/LegalEntityPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import { ProductsPage } from "./pages/ProductsPage";
import { SolutionDetailPage } from "./pages/SolutionDetailPage";
import { SolutionsPage } from "./pages/SolutionsPage";
import { ThorSeriesPage } from "./pages/ThorSeriesPage";
import { TrainingPage } from "./pages/TrainingPage";
import { PrivacyPage, TermsPage } from "./pages/legal";

export const AppRoutes = () => {
  const e = useLocation();
  const t = React.useRef(e.pathname);
  React.useEffect(() => {
    applyRouteMeta(getRouteMeta(e.pathname));
  }, [e.pathname]);
  React.useEffect(() => {
    const n = t.current;
    const r = e.pathname;
    if (n !== r) {
      window.requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "auto",
        });
      });
    }
    t.current = r;
  }, [e.pathname]);
  return (
    <ComingSoonProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product" element={<Navigate to="/products/thor-ego" replace={true} />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/thor-ego" element={<ThorSeriesPage />} />
        <Route path="/products/thor-v2" element={<Navigate to="/products/thor-duo" replace={true} />} />
        <Route path="/products/thor-v4" element={<Navigate to="/products/thor-quad" replace={true} />} />
        <Route path="/products/thor-v6" element={<Navigate to="/products/thor-hex" replace={true} />} />
        <Route path="/products/:slug" element={<ProductDetailPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/solutions/:slug" element={<SolutionDetailPage />} />
        <Route path="/solutions/capture/data-platform" element={<DataPlatformPage />} />
        <Route path="/solutions/workstation/training" element={<Navigate to="/training" replace={true} />} />
        <Route path="/platform" element={<Navigate to="/solutions/capture/data-platform" replace={true} />} />
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/resources/integration" element={<IntegrationPage />} />
        <Route path="/resources" element={<Navigate to="/resources/integration" replace={true} />} />
        <Route path="/developers" element={<Navigate to="/resources/integration" replace={true} />} />
        <Route path="/products/omnivue" element={<Navigate to="/products/thor-v2" replace={true} />} />
        <Route path="/products/aego-band" element={<Navigate to="/products/thor-v4" replace={true} />} />
        <Route path="/products/aego-glove" element={<Navigate to="/products/thor-v6" replace={true} />} />
        <Route path="/products/data-platform" element={<Navigate to="/platform" replace={true} />} />
        <Route path="/product/:slug" element={<LegacyProductRedirect />} />
        <Route path="/demo" element={<Navigate to="/solutions" replace={true} />} />
        <Route path="/news" element={<Navigate to="/" replace={true} />} />
        <Route path="/news/:id" element={<Navigate to="/" replace={true} />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/legal-entity" element={<LegalEntityPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/admin" element={<Navigate to="/" replace={true} />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/products/egoforce-kit" element={<ComingSoonPage title="THOR Capture Stack" />} />
        <Route path="/products/forcealign" element={<ComingSoonPage title="EGO-to-Robot" />} />
        <Route path="/products/forcebench" element={<ComingSoonPage title="AEgo Edge Hub" />} />
        <Route path="/products/actrium-studio" element={<ComingSoonPage title="AEgo Engine" />} />
        <Route path="/contact" element={<Navigate to="/about" replace={true} />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ComingSoonProvider>
  );
};
